import React from "react";
import RecordTableAdapter from "./RecordTable";
import { useGetGoogleAdsRecordListQuery, useGetLineAdsRecordListQuery, useRemoveGoogleAdsRecordMutation, useRemoveLineAdsRecordMutation } from "../../../generated/graphql";

export default function LineRecordTable() {
  return (
    <RecordTableAdapter
      useGetRecordListQuery={useGetLineAdsRecordListQuery}
      useRemoveRecordMutation={useRemoveLineAdsRecordMutation}
      recordKey="lineAdsRecords"
      recordName="LINE Ads 報表名稱"
      downloadPathPrefix="line-ads"
      refetchQueryName="getLineAdsRecordList"
    />
  );
}